var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "tree-path flex-start-start" },
    [
      _vm._l(_vm.parents, function (child) {
        return _c("li", { key: child.id }, [
          _c(
            "a",
            {
              class: { active: child === _vm.item },
              attrs: { href: _vm.UrlService.urlFor(child) },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.setCurrent(child)
                },
              },
            },
            [_vm._v("\n\t\t\t" + _vm._s(child.product.dn) + "\n\t\t")]
          ),
        ])
      }),
      _vm._v(" "),
      _vm.isLimited()
        ? _c("li", { staticClass: "text-warning ml-auto" }, [
            _vm._v(
              "\n\t\tLimité à " +
                _vm._s(_vm.ShopService.shop.MaxNumberCommands) +
                " articles par " +
                _vm._s(_vm.ShopService.shop.DeliveryTimeSlot) +
                " minutes\n\t"
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }